/** Construct a poster frame URL for an imgix video using the video-thumbnail API. */
export const getVideoThumbnailUrl = (videoUrl: string): string => {
  try {
    const url = new URL(videoUrl);
    url.searchParams.set('video-thumbnail', 'auto');
    url.searchParams.set('fm', 'jpg');

    return url.toString();
  } catch {
    return videoUrl;
  }
};
